import React, { Component } from 'react'; 
import axios from '../../axios';
import * as url from '../../utils/url';
import Plot from "../../utils/customPlotly";
import moment from 'moment';


class TotalActionCount extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      actionCount:this.props.actionCount,
      count:null,
      isAllEOPage: this.props.eo_id==null? true: false,
    }

    //  console.log(this.props)
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.actionCount !== prevProps.actionCount) {
      this.getActionStats()
    }
  }

  
componentDidMount(){
  this.getActionStats()
}

  
getActionStats = ()=>{
    // console.log('called!')
    let params = {
        enterpriseId: this.props.eo_id
      }
      axios.get(url.getTotalActionCount, {
        params: params })
        .then( (result)=> {
        // console.log('data---',  result)
        let data =  result.data.data, count;
        
        if(data && data[0] && data[0].count) {
          count = data[0].count
        }else{
          count =false;
        }

        this.setState({ count })   
      })
}



render() { 
    let{count, isAllEOPage}=this.state
  // console.log('count----', count)
    if( count>0 ){
        return ( 
          <div className="enterpriseObjStatInt">
            {count}
          </div>
        )
    } else if(!count || count == 0 || count==false){
      return (
        <span>
          <div className={isAllEOPage?'':'actionStatsNA'}> No actions </div>
          {/* <p className="actionStatsNAsubtitle"> linked to {isAllEOPage?"objective(s)":"objective"} </p> */}
          <p className="actionStatsNAsubtitle"> linked </p>
        </span>
        )
    } else{
      return <div className={isAllEOPage?'actionStatsNA mt14p':'actionStatsNA'} >Loading...</div>
    }
  }
}
 
export default TotalActionCount;